import {Controller} from "@hotwired/stimulus";
import axios from "axios";

export default class extends Controller {


    articleGtag(e) {
        const locale = window.location.pathname.split("/")[1].toUpperCase();
        gtag("event", "select_article", {
            language: locale.length > 2 ? "EN" : locale,
            title: e.params.title,
            category: e.params.category,
            index: e.params.index
        });
    }
    shareArticleGtag(e) {
        const locale = window.location.pathname.split("/")[1].toUpperCase();
        gtag("event", "share_article", {
            language: locale.length > 2 ? "EN" : locale,
            title: e.params.title,
            category: e.params.category,
            index: e.params.index,
            network: e.params.network
        });
    }
}